export default {

	fr: {
		loading: "Chargement en cours",

		settings: "Options",
		language: "Langue",
		genre: "Genre",
		feminine: "Féminin",
		masculine: "Masculin",
		volume: "Volume",
		musics: "Musiques",
		sounds: "Sons",
		quality: "Qualité",
		low: "Faible",
		high: "Élevée",
		zoom_auto: "Zoom auto",
		zoom_level: "Niveau de zoom",
		credits: "Crédits",
		reset: "Réinitialiser",
		data: "Données",
		code_and_design: "Code et Concept",
		art: "Graphisme",
		close: "Fermer",
		tap_anywhere_to_close: "Toucher pour fermer",
		back: "Retour",
		continue: "Continuer",
		restart_game: "Recommencer",

		paused: "Pause",
		back_to_home: "Retour à l'accueil",
		quests: "Quests",
		resume_game: "Reprendre la partie",
		new_game: "Nouvelle partie",

		effect_duration: "Dure pendant (X) déplacement(s).",

		game_over: "Partie terminée",
		victory: "Victoire",
		killed_enemies: "Ennemis tués",
		collected_emeralds: "Émeraudes récupérées",
		completed_levels: "Niveaux terminés",
		final_score: "Score final",

		new_unlocked_character: "Nouveau personnage débloqué !",

		fullscreen: "Plein écran",
		start: "Commencer",
		play: "Jouer",
		zany_sentence: "Allez les marmots !<br>Qui sera le prochain à tenter l'aventure ?",
		brower_alert: "Le jeu est optimisé pour le navigateur Chrome.",

		hero_locked_sentence: "Terminer des expéditions pour débloquer ce personnage.",
		// diamonds_left_1: "Plus que ",
		// diamonds_left_2: "diamants à récupérer pour débloquer ce personnage.",

		merchant_sentence: "Achetez donc quelques-un de mes talismans. Vous en aurez besoin pour continuer votre aventure !",
		crown_tooltip: "Cet ennemi est un boss !",

		developer: "Développeur",
		game_artist: "Game artist",
		sound_designer: "Sound designer",
		reset_progression_sentence_1: "Vous pouvez réinitialiser toute votre progression sauvegardée.",
		reset_progression_sentence_2: "Attention, cette action est irréversible, vous ne pourrez plus récupérer votre progression !",
		reset_progression: "Réinitialiser votre progression",
		delete_progression: "Confirmer",

		skip_tuto: "Passer",
	},



	en: {
		loading: "Loading",
		settings: "Settings",
		language: "Language",
		genre: "Genre",
		feminine: "Female",
		masculine: "Male",
		volume: "Volume",
		musics: "Musics",
		sounds: "Sounds",
		quality: "Quality",
		low: "Low",
		high: "High",
		zoom_auto: "Zoom auto",
		zoom_level: "Zoom level",
		credits: "Credits",
		reset: "Reset",
		data: "Data",
		code_and_design: "Code and Design",
		art: "Art",
		close: "Close",
		tap_anywhere_to_close: "Tap to close",
		back: "Back",
		continue: "Continue",
		restart_game: "Restart",

		paused: "Paused",
		back_to_home: "Back to home",
		quests: "Quests",
		resume_game: "Resume game",
		new_game: "New game",

		effect_duration: "Lasts for (X) move(s).",

		game_over: "Game over",
		victory: "Victory",
		killed_enemies: "Killed enemies",
		collected_emeralds: "Collected emeralds",
		completed_levels: "Completed levels",
		final_score: "Final score",

		new_unlocked_character: "New character unlocked!",

		fullscreen: "Fullscreen",
		start: "Start",
		play: "Play",
		zany_sentence: "Come on, kids!<br>Who will be the next to try this adventure?",
		brower_alert: "The game is optimized for Chrome browser.",

		hero_locked_sentence: "Complete expeditions to unlock this character.",
		// diamonds_left_1: "Still ",
		// diamonds_left_2: "diamonds to collect to unlock this character.",


		merchant_sentence: "Buy some of my talismans. You'll need them to continue your adventure!",
		crown_tooltip: "This enemy is a boss!",

		developer: "Developer",
		game_artist: "Game artist",
		sound_designer: "Sound designer",
		reset_progression_sentence_1: "You can reset all your saved data.",
		reset_progression_sentence_2: "Please note, this action is irreversible, you will no longer be able to recover your progress!",
		reset_progression: "Reset progression",
		delete_progression: "Confirm",

		skip_tuto: "Skip",
	}


}